///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rfq = abcsetup.rfq || {};
abcsetup.rfq.bid_requests = abcsetup.rfq.bid_requests || {};
abcsetup.rfq.bid_requests.batch_import = abcsetup.rfq.bid_requests.batch_import || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rfq.bid_requests.batch_import = {
    init: function() {
        $(document).on('change', '#js-batch-item-import', function(e) {
            let file = e.target.files[0];

            if (! file) {
                $('#js-batch-import-clear').addClass('d-none');
                return;
            }

            $('#js-batch-import-clear').removeClass('d-none');

            const formData = new FormData();
            formData.append('file', file);
            formData.append('lcu_rfq_Bid_type_id', 30);

            abcsetup.blockUI(true);

            axios.post('/api/rfq/bid_requests/large_customer_usage_validate', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                } 
            })
            .then(response => {
                abcsetup.unblockUI();
                const data = response.data;

                if (data.valid) {
                    let modal = abcsetup.rfq.bid_requests.batch_import._getSuccessModal(data.success_message);

                    $(modal).modal('show');

                    $('#js-submit-event-btn').attr('disabled', false);
                } else {
                    const error_messages = data.errors
                        .split('\n')
                        .filter(line => line.trim())
                        .map(line => `<li>${line}</li>`)
                        .join('');

                    let modal = abcsetup.rfq.bid_requests.batch_import._getSuccessModal(
                        `There were errors found in your import template. Please correct them & try again. ${error_messages}`,
                        'Failed'
                    );

                    $(modal).modal('show');

                    $('#js-submit-event-btn').attr('disabled', true);
                }
            })
            .catch(error => {
                console.error(error);
                abcsetup.unblockUI();
                abcsetup.alerts.show('Error submitting template', 'There was an error submitting your template for validation. Please reach out to support for more help.');
            });
        });

        $(document).on('click', '#js-batch-import-clear', function(e) {
            $('#js-batch-item-import').val('');
            $('#js-batch-import-clear').addClass('d-none');
        });
    },

    _getSuccessModal: function(content, success = 'Successful') {
        return `
            <div class="modal fade top-most not-full-screen" tabindex="-1" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document" style="min-width: 50%;">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Validation ${success}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <div class="modal-body" style="max-width: 75vw; max-height: 75vh; overflow-y: auto; overflow-x: auto;">
                            ${content}
                        </div>

                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
};